import red from "@material-ui/core/colors/red";

const styles = theme => ({
  card: {
    maxWidth: 345,
    minWidth: 345
  },
  media: {
    height: 0,
    paddingTop: "56.25%" // 16:9
  },
  headerText: {
    textAlign: "center"
  },
  formDialogContent: {
    margin: "0px 60px 0px 0px"
  },
  actions: {
    display: "flex",
    backgroundColor: "rgba(245,245,245,1)"
  },
  avatar: {
    backgroundColor: red[500],
    float: "right"
  },
  button: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    alignContent: "space-between",
    justifyContent: "flex-start",
    // margin: 'auto',
    width: `${75}%`,
    padding: "5px"
  },
  time: {
    // padding: '5px'
  }
});

export default styles;
